import { IconCircleCheck, IconXboxX } from "@tabler/icons-react";

const HandleResult = ({ data }) => {
  const type = typeof data;
  if (type === "boolean") {
    return data ? <IconCircleCheck color="green" /> : <IconXboxX color="red" />;
  }

  if (type === "null") return "";

  if (data === undefined) return "";

  if (type === "object") return "";

  return data;
};

export default HandleResult;
